module.exports = __webpack_public_path__ + "img/Google_pay_icon.2d806d72.png";